import { Validator } from 'fluentvalidation-ts';
import { ServingLine } from '@/models';

export class ServingLineValidator extends Validator<ServingLine> {
  constructor() {
    super();

    this.ruleFor('mealCountServedFirstMeal')
      .greaterThan(0)
      .withMessage('First Meal must contain a count or')
      .when(r =>
        r.mealCountServedSecondMeal == 0 &&
        r.mealCountServedAdultProgram == 0 &&
        r.mealCountServedAdultNonProgram == 0);

    this.ruleFor('mealCountServedSecondMeal')
      .greaterThan(0)
      .withMessage('Second Meal must contain a count or')
      .when(r =>
        r.mealCountServedFirstMeal == 0 &&
        r.mealCountServedAdultProgram == 0 &&
        r.mealCountServedAdultNonProgram == 0);

    this.ruleFor('mealCountServedAdultProgram')
      .greaterThan(0)
      .withMessage('Adult Program must contain a count or')
      .when(r =>
        r.mealCountServedFirstMeal == 0 &&
        r.mealCountServedSecondMeal == 0 &&
        r.mealCountServedAdultNonProgram == 0);

    this.ruleFor('mealCountServedAdultNonProgram')
      .greaterThan(0)
      .withMessage('Adult Non Program must contain a count or')
      .when(r =>
        r.mealCountServedFirstMeal == 0 &&
        r.mealCountServedSecondMeal == 0 &&
        r.mealCountServedAdultProgram == 0);
  }
}
